import { Component, Input } from '@angular/core';
import { ActivatedRoute, NavigationExtras, QueryParamsHandling, Router } from '@angular/router';

@Component({
  selector: 'app-no-record',
  templateUrl: './no-record.component.html',
  styleUrls: ['./no-record.component.scss']
})
export class NoRecordComponent {
  @Input() title = '';
  @Input() description = '';
  @Input() buttonLabel = '';
  @Input() redirectTo: string | any[] = '';
  @Input() queryParams: Record<string, any> | null = null;
  @Input() queryParamsHandling: QueryParamsHandling | null = null;
  @Input() height = 'min(50vh, 360px)';
  @Input() imageSrc = 'assets/images/temp/no_data.svg';
  @Input() imageAlt = 'No records found';

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  onButtonClick(): void {
    if (!this.redirectTo) {
      return;
    }

    const commands = Array.isArray(this.redirectTo) ? this.redirectTo : [this.redirectTo];
    const extras: NavigationExtras = {};

    if (this.queryParams) {
      extras.queryParams = this.queryParams;
    }

    if (this.queryParamsHandling) {
      extras.queryParamsHandling = this.queryParamsHandling;
    }

    const firstCommand = commands[0];
    if (typeof firstCommand === 'string' && firstCommand.startsWith('.')) {
      extras.relativeTo = this.route;
    }

    this.router.navigate(commands, extras);
  }
}
